const permissions = {
    READ_CLIENT_MANAGEMENT: ["GET"],
    CREATE_CLIENT_MANAGEMENT: ["POST"],
    UPDATE_CLIENT_MANAGEMENT: ["PUT"],
    DELETE_CLIENT_MANAGEMENT: ["DELETE"],
    ALL_CLIENT_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_EMPLOYEE_MANAGEMENT: ["GET"],
    CREATE_EMPLOYEE_MANAGEMENT: ["POST"],
    UPDATE_EMPLOYEE_MANAGEMENT: ["PUT"],
    DELETE_EMPLOYEE_MANAGEMENT: ["DELETE"],
    ALL_EMPLOYEE_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_MOBILIZATION_MANAGEMENT: ["GET"],
    CREATE_MOBILIZATION_MANAGEMENT: ["POST"],
    UPDATE_MOBILIZATION_MANAGEMENT: ["PUT"],
    DELETE_MOBILIZATION_MANAGEMENT: ["DELETE"],
    ALL_MOBILIZATION_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_MODULE_MANAGEMENT: ["GET"],
    CREATE_MODULE_MANAGEMENT: ["POST"],
    UPDATE_MODULE_MANAGEMENT: ["PUT"],
    DELETE_MODULE_MANAGEMENT: ["DELETE"],
    ALL_MODULE_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_PERMISSION_MANAGEMENT: ["GET"],
    CREATE_PERMISSION_MANAGEMENT: ["POST"],
    UPDATE_PERMISSION_MANAGEMENT: ["PUT"],
    DELETE_PERMISSION_MANAGEMENT: ["DELETE"],
    ALL_PERMISSION_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_ROLE_MANAGEMENT: ["GET"],
    CREATE_ROLE_MANAGEMENT: ["POST"],
    UPDATE_ROLE_MANAGEMENT: ["PUT"],
    DELETE_ROLE_MANAGEMENT: ["DELETE"],
    ALL_ROLE_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_SUPPLIER_MANAGEMENT: ["GET"],
    CREATE_SUPPLIER_MANAGEMENT: ["POST"],
    UPDATE_SUPPLIER_MANAGEMENT: ["PUT"],
    DELETE_SUPPLIER_MANAGEMENT: ["DELETE"],
    ALL_SUPPLIER_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_USER_MANAGEMENT: ["GET"],
    CREATE_USER_MANAGEMENT: ["POST"],
    UPDATE_USER_MANAGEMENT: ["PUT"],
    DELETE_USER_MANAGEMENT: ["DELETE"],
    ALL_USER_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_ANALYTICS_MANAGEMENT: ["GET"],
    CREATE_ANALYTICS_MANAGEMENT: ["POST"],
    UPDATE_ANALYTICS_MANAGEMENT: ["PUT"],
    DELETE_ANALYTICS_MANAGEMENT: ["DELETE"],
    ALL_ANALYTICS_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_PURCHASE_ORDER_MANAGEMENT: ["GET"],
    CREATE_PURCHASE_ORDER_MANAGEMENT: ["POST"],
    UPDATE_PURCHASE_ORDER_MANAGEMENT: ["PUT"],
    DELETE_PURCHASE_ORDER_MANAGEMENT: ["DELETE"],
    ALL_PURCHASE_ORDER_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_INVOICE_MANAGEMENT: ["GET"],
    CREATE_INVOICE_MANAGEMENT: ["POST"],
    UPDATE_INVOICE_MANAGEMENT: ["PUT"],
    DELETE_INVOICE_MANAGEMENT: ["DELETE"],
    ALL_INVOICE_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_DOCUMENT_MANAGEMENT: ["GET"],
    CREATE_DOCUMENT_MANAGEMENT: ["POST"],
    UPDATE_DOCUMENT_MANAGEMENT: ["PUT"],
    DELETE_DOCUMENT_MANAGEMENT: ["DELETE"],
    ALL_DOCUMENT_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_QUOTATION_MANAGEMENT: ["GET"],
    CREATE_QUOTATION_MANAGEMENT: ["POST"],
    UPDATE_QUOTATION_MANAGEMENT: ["PUT"],
    DELETE_QUOTATION_MANAGEMENT: ["DELETE"],
    ALL_QUOTATION_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_ASSET_MANAGEMENT: ["GET"],
    CREATE_ASSET_MANAGEMENT: ["POST"],
    UPDATE_ASSET_MANAGEMENT: ["PUT"],
    DELETE_ASSET_MANAGEMENT: ["DELETE"],
    ALL_ASSET_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_SERVICE_AGREEMENT_MANAGEMENT: ["GET"],
    CREATE_SERVICE_AGREEMENT_MANAGEMENT: ["POST"],
    UPDATE_SERVICE_AGREEMENT_MANAGEMENT: ["PUT"],
    DELETE_SERVICE_AGREEMENT_MANAGEMENT: ["DELETE"],
    ALL_SERVICE_AGREEMENT_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_TIMESHEET_MANAGEMENT: ["GET"],
    CREATE_TIMESHEET_MANAGEMENT: ["POST"],
    UPDATE_TIMESHEET_MANAGEMENT: ["PUT"],
    DELETE_TIMESHEET_MANAGEMENT: ["DELETE"],
    ALL_TIMESHEET_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_SALES_ENQUIRY_MANAGEMENT: ["GET"],
    CREATE_SALES_ENQUIRY_MANAGEMENT: ["POST"],
    UPDATE_SALES_ENQUIRY_MANAGEMENT: ["PUT"],
    DELETE_SALES_ENQUIRY_MANAGEMENT: ["DELETE"],
    ALL_SALES_ENQUIRY_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_PROJECT_MANAGEMENT: ["GET"],
    CREATE_PROJECT_MANAGEMENT: ["POST"],
    UPDATE_PROJECT_MANAGEMENT: ["PUT"],
    DELETE_PROJECT_MANAGEMENT: ["DELETE"],
    ALL_PROJECT_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_AR_ENGINEERING_PROFILE_MANAGEMENT: ["GET"],
    CREATE_AR_ENGINEERING_PROFILE_MANAGEMENT: ["POST"],
    UPDATE_AR_ENGINEERING_PROFILE_MANAGEMENT: ["PUT"],
    DELETE_AR_ENGINEERING_PROFILE_MANAGEMENT: ["DELETE"],
    ALL_AR_ENGINEERING_PROFILE_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],

    READ_PERSONAL_TRACKING_MANAGEMENT: ["GET"],
    CREATE_PERSONAL_TRACKING_MANAGEMENT: ["POST"],
    UPDATE_PERSONAL_TRACKING_MANAGEMENT: ["PUT"],
    DELETE_PERSONAL_TRACKING_MANAGEMENT: ["DELETE"],
    ALL_PERSONAL_TRACKING_MANAGEMENT: ["GET", "POST", "PUT", "DELETE"],
};

const modules = {
    CLIENT_MANAGEMENT: "CLIENT_MANAGEMENT",
    EMPLOYEE_MANAGEMENT: "EMPLOYEE_MANAGEMENT",
    MOBILIZATION_MANAGEMENT: "MOBILIZATION_MANAGEMENT",
    MODULE_MANAGEMENT: "MODULE_MANAGEMENT",
    PERMISSION_MANAGEMENT: "PERMISSION_MANAGEMENT",
    ROLE_MANAGEMENT: "ROLE_MANAGEMENT",
    SUPPLIER_MANAGEMENT: "SUPPLIER_MANAGEMENT",
    USER_MANAGEMENT: "USER_MANAGEMENT",
    ANALYTICS_MANAGEMENT: "ANALYTICS_MANAGEMENT",
    INVOICE_MANAGEMENT: "INVOICE_MANAGEMENT",
    PURCHASE_ORDER_MANAGEMENT: "PURCHASE_ORDER_MANAGEMENT",
    DOCUMENT_MANAGEMENT: "DOCUMENT_MANAGEMENT",
    QUOTATION_MANAGEMENT: "QUOTATION_MANAGEMENT",
    ASSET_MANAGEMENT: "ASSET_MANAGEMENT",
    SERVICE_AGREEMENT_MANAGEMENT: "SERVICE_AGREEMENT_MANAGEMENT",
    TIMESHEET_MANAGEMENT: "TIMESHEET_MANAGEMENT",
    SALES_ENQUIRY_MANAGEMENT: "SALES_ENQUIRY_MANAGEMENT",
    PROJECT_MANAGEMENT: "PROJECT_MANAGEMENT",
    AR_ENGINEERING_PROFILE_MANAGEMENT: "AR_ENGINEERING_PROFILE_MANAGEMENT",
    PERSONAL_TRACKING_MANAGEMENT: "PERSONAL_TRACKING_MANAGEMENT",
};

export { permissions, modules };
